<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { LOCALES } from '../i18n/index'

const { locale, t } = useI18n()

const current = computed({
  get: () => locale.value,
  // Setting the reactive locale re-renders every translated string in place, and
  // `useLocaleRouting` picks the change up to push the locale's URL and persist
  // the choice. No page reload — see AGENTS.md §7.
  set: (code: string) => {
    locale.value = code
  },
})
</script>

<template>
  <label class="language-switcher">
    <span class="visually-hidden">{{ t('language.select') }}</span>
    <select v-model="current" :aria-label="t('language.select')">
      <option v-for="entry in LOCALES" :key="entry.code" :value="entry.code">
        {{ entry.flag }} {{ entry.nativeName }}
      </option>
    </select>
  </label>
</template>
